import { client } from '../../../../../shared/services/apiClient';
import { ApiKeyResponse, CreateApiKeyRequest } from '../../../../settings/api-keys/models/ApiKeyResponse';

export const getAccountApiKeys = async (accountId: number): Promise<ApiKeyResponse[]> => {
  return client(true, true)
    .get<ApiKeyResponse[]>(`/admin/users/api-keys/${accountId}`)
    .then((response) => response.data);
};

export const createAccountApiKey = async (
  accountId: number,
  request: CreateApiKeyRequest
): Promise<ApiKeyResponse> => {
  return client(true, true)
    .post<ApiKeyResponse>(`/admin/users/api-keys/${accountId}`, request)
    .then((response) => response.data);
};


